import classNames from 'classnames';
import { BlueSwirl } from '../icons';
import { CursiveBlueLabel } from './CursiveBlueLabel';

type Props = {
    children: React.ReactNode;
    class?: string;
    className?: string;
    style?: React.CSSProperties;
};
export function SwirlyBox({
    children,
    class: _class,
    className,
    ...props
}: Props) {
    return (
        <div
            {...props}
            className={classNames(
                'relative inline-block self-center text-center',
                _class,
                className,
            )}
        >
            <BlueSwirl />
            <div className="absolute inset-0 flex items-center justify-center py-20">
                <CursiveBlueLabel>{children}</CursiveBlueLabel>
            </div>
        </div>
    );
}
